import { UrlConstants } from "src/app/shared/constants/url.constants";
export class ApiApplicationSearchConstants {
    static URL = UrlConstants.API_V2 + "ApplicationSearch";
    static FUNCTION_SEARCH = "Search";
    static FUNCTION_GET_SEARCHES = "GetApplicationSearches";
    static FUNCTION_GET_SEARCH_LAYER_FIELDS = "GetSearchLayerFields";
}
